<template>
  <header class="header">
    <v-stepper v-model="step"
               class="header-stepper"
               alt-labels>

      <v-stepper-header>
        <v-stepper-step step="1"
                        :complete="isFirstStepDone"
                        editable
                        :edit-icon="$vuetify.icons.complete"
                        @click="emitStep({ step: 1, editable: true })">
          Conteúdo
        </v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step step="2"
                        :complete="isSecondStepDone"
                        :editable="isFirstStepDone"
                        :edit-icon="$vuetify.icons.complete"
                        @click="emitStep({ step: 2, editable: isFirstStepDone })">
          Destinatários
        </v-stepper-step>

      </v-stepper-header>
    </v-stepper>
  </header>
</template>

<script>
import EventBus from "@packages/event-bus";

export default {
  components: {},

  computed: {},

  data() {
    return {
      step: 1,
      smsData: undefined,
      isFirstStepDone: false,
      isSecondStepDone: false,
    };
  },

  created() {
    EventBus.$on("SET_SMS_FORM_STEP", this.setStep);
  },

  beforeDestroy() {
    EventBus.$off("SET_SMS_FORM_STEP", this.setStep);
  },

  methods: {
    setStep(stepVal) {
      this.step = stepVal;

      if (stepVal === 1) {
        this.isFirstStepDone = true;
      } else if (stepVal === 2) {
        this.isSecondStepDone = true;
      }
    },
    setData(smsData) {
      this.smsData = smsData;

      this.setAvaiableSteps();
    },
    setAvaiableSteps(smsData) {
      if (smsData.content || smsData.title) {
        this.isFirstStepDone = true;
      }

      if (smsData.sendType) {
        this.isSecondStepDone = true;
      }

      if (smsData.schedulerDate) {
        this.isThirdStepDone = true;
      }

      this.smsData = smsData;
    },
    emitStep({ step, editable }) {
      if (editable) {
        EventBus.$emit("SET_SMS_FORM_STEP", step);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.header {
  .header-stepper {
    box-shadow: none;
  }
}
</style>
